import { render, staticRenderFns } from "./DialogSeniorSearch.vue?vue&type=template&id=5a68af87&"
import script from "./DialogSeniorSearch.vue?vue&type=script&lang=js&"
export * from "./DialogSeniorSearch.vue?vue&type=script&lang=js&"
import style0 from "./DialogSeniorSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports